<template>
    <b-container class="processStep">
        <b-row class="processStepFlex" :id="'processStep'+number">
            <b-col lg="6" sm="12">
                <img :id="'animProcessStep'+number" class="processStepImg" :src="getImg(img)" :alt="title">
            </b-col>
            <b-col lg="6" sm="12" class="processStepContent">
                <h2>{{title}}</h2>
                <p class="pink bold">Description</p>
                <p>{{description}}</p>
                <p class="pink bold">Tasks</p>
                <ul>
                    <li v-for="(task, i) in tasks" :key="i">+ {{task}}</li>
                </ul>
                <p class="pink bold">Goals</p>
                <ul>
                    <li v-for="(goal, i) in goals" :key="i">+ {{goal}}</li>
                </ul>
            </b-col>
        </b-row>
        <hr :id="'hrStep'+number">
        <!-- <div :id="'triggerProcessStep'+number"></div> -->
    </b-container>
</template>

<script>
export default {
    name: "processStep",
    props: {
        title: String,
        description: String,
        tasks: Array,
        goals: Array,
        img: String,
        alt: String,
        number: Number
    },
    methods: {
        getImg: function(img) {
            return require('@/assets/imagesProcess/'+img)
        }
    },
    // mounted() {
    //     console.log(this.number)

    //     if(this.number != 0) {

    //         var anim = this.$scrollmagic.scene({
    //           triggerElement: 'triggerProcessStep1',
    //           duration: 500
    //         })

    //         .setTween("#animProcessStep"+this.number, 0.5, {opacity:1})
    //         .addIndicators({ name: 'Anim' + this.number })
    //         this.$scrollmagic.addScene([anim])
    //     }   

    // }
}
</script>

<style style="scss" scoped>
img {
    width:100%;
}

/* .processStepImg {
    opacity:0;
} */

ul {
    padding-inline-start: 0px;
}

li {
    padding: 5px 0;
}

.processStepContent{
    padding: 0 30px;
}

.processStepFlex{
    display:flex;
    justify-content: space-between;
    align-items: flex-start;
}

#processStep1, #processStep3 {
    flex-direction: row-reverse;
}

#hrStep3 {
    display: none;
}

@media (max-width:991px) {
    img {
        margin-bottom:50px;
        width:80%;
        margin-left:10%;
    }
}
</style>